import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayVerifiedIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.58 1.25L12.08 0.25C12.03 0.25 11.98 0.25 11.92 0.25L2.42 1.25C2.04 1.29 1.75 1.62 1.75 2L1.84 12.68C1.86 15.31 2.88 17.81 4.69 19.73C6.8 21.97 9.22 23.31 11.88 23.73C11.96 23.74 12.04 23.74 12.11 23.73C14.77 23.31 17.19 21.96 19.3 19.73C21.12 17.81 22.13 15.3 22.15 12.68L22.24 2C22.24 1.61 21.95 1.29 21.57 1.25H21.58ZM20.66 12.67C20.64 14.92 19.77 17.06 18.22 18.71C16.37 20.67 14.28 21.85 12 22.24C9.72 21.85 7.63 20.66 5.78 18.71C4.23 17.07 3.36 14.92 3.34 12.67L3.25 2.67L12 1.75L20.75 2.67L20.66 12.67Z"
        fill={color}
      />
      <path
        d="M7.47 11.72C7.25 11.46 6.85 11.43 6.59 11.65C6.33 11.87 6.3 12.27 6.52 12.53L10.27 16.91C10.53 17.23 11.07 17.19 11.27 16.83L17.52 6.82997C17.7 6.53997 17.61 6.14997 17.32 5.96997C17.03 5.78997 16.64 5.87997 16.46 6.16997L10.66 15.45L7.46 11.72H7.47Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayVerifiedIcon.displayName = 'PayVerifiedIcon';
